module.exports = __webpack_public_path__ + "icons8-viber-480.png?e18e88b1ec5c199715015437e8794f2c";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons8-viber-480.png
// module id = 1847
// module chunks = 0